import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IPhysiologicalData, /* IphysiologicalDataPayload */ 
IUnit} from '../../entities/PhysiologicalData/PhysiologicalData.ts';
import { IPhysiologicalDataDetails } from '../../entities/PhysiologicalData/PhysiologicalData.ts';
import { IPhysiologicalType } from '../../entities/PhysiologicalData/PhysiologicalData.ts';

export class PhysiologicalDataApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/physiologicals`;

    public static apiUrls = {
        getPhysiologicals: `${BaseApi.apiUrl}/patients/:id/physiologicals`,
        getPhysiologicalById: `${PhysiologicalDataApi.baseApiUrl}/:PhysiologicalDataId`,
        getPhysiologicalUnitsByType: `${PhysiologicalDataApi.apiUrl}/physiologicalTypes/:PhysiologicalTypeId/units`,
        getPhysiologicalTypes: `${BaseApi.apiUrl}/physiologicalTypes`,
        postPhysiological: `${PhysiologicalDataApi.baseApiUrl}`,
        putPhysiological: `${PhysiologicalDataApi.baseApiUrl}/:PhysiologicalDataId`,
        deletePhysiological: `${PhysiologicalDataApi.baseApiUrl}/:PhysiologicalDataId`,
    };

    public static async getPhysiologicalDatas(patientId: string): Promise<IPhysiologicalData[]> {
        return this.sendApiRequest<IPhysiologicalData[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPhysiologicals,
            id: patientId
        });
    }

    public static async getPhysiologicalDataById(physiologicaldataId: string): Promise<IPhysiologicalDataDetails> {
        return this.sendApiRequest<IPhysiologicalDataDetails>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPhysiologicalById.replace(':PhysiologicalDataId', physiologicaldataId),
        });
    }

    public static async getPhysiologicalUnitsByType(physiologicalTypeId: string): Promise<IUnit[]> {
        return this.sendApiRequest<IUnit[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPhysiologicalUnitsByType.replace(':PhysiologicalTypeId', physiologicalTypeId),
        });
    }

    public static async getPhysiologicalTypes(): Promise<IPhysiologicalType[]> {
        return this.sendApiRequest<IPhysiologicalType[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPhysiologicalTypes,
        });
    }

    public static async postPhysiological(data: IPhysiologicalDataDetails): Promise<IPhysiologicalDataDetails> {
        return this.sendApiRequest<IPhysiologicalDataDetails>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postPhysiological,
            data: data,
        });
    }

    public static async putPhysiological(physiologicaldataId: string, data: IPhysiologicalDataDetails): Promise<IPhysiologicalDataDetails> {
        return this.sendApiRequest<IPhysiologicalDataDetails>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putPhysiological.replace(':PhysiologicalDataId', physiologicaldataId),
            data: data,
            id: physiologicaldataId
        });
    }

    public static async deletePhysiologicalData(physiologicaldataId: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deletePhysiological.replace(':PhysiologicalDataId', physiologicaldataId),
            id: physiologicaldataId
        });
    }
}
